var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { PureComponent } from 'react';
import { injectIntl } from 'react-intl';
import Amount from '../../Payment/PaymentAmountSelector';
import { Form, FormSpy } from 'react-final-form';
import PaymentMethodSelector from '../../Payment/PaymentMethodSelector';
import SelectedPaymentMethod from '../../Payment/SelectedPaymentMethod';
import * as PaymentAccountForms from '../../Payment/PaymentAccountForms';
import Money from '../../../../components/Money';
import { getSupportedAmounts, matchProviderType } from '../../Payment';
import marked from 'marked';
import translate from '../../../../lib/utils/translate';

var STEPS = {
  SELECT_PAYMENT_METHOD: 'SELECT_PAYMENT_METHOD',
  FILL_IN: 'FILL_IN'
};

var Deposit = function (_PureComponent) {
  _inherits(Deposit, _PureComponent);

  function Deposit(props) {
    _classCallCheck(this, Deposit);

    var _this = _possibleConstructorReturn(this, (Deposit.__proto__ || Object.getPrototypeOf(Deposit)).call(this, props));

    _initialiseProps.call(_this);

    var _this$props = _this.props,
        currency = _this$props.currency,
        methods = _this$props.methods,
        initialState = _this$props.initialState;


    var selectedMethod = initialState ? initialState.selectedMethod : methods[0];

    var amounts = getSupportedAmounts(currency, selectedMethod.providerType);
    var currentAmount = initialState ? initialState.currentAmount : amounts[0];

    var selectedAccount = initialState ? initialState.selectedAccount : selectedMethod.accounts[0] || {};

    _this.state = {
      currentStep: initialState ? initialState.currentStep : STEPS.SELECT_PAYMENT_METHOD,
      selectedMethod: selectedMethod,
      selectedAccount: selectedAccount,
      currentAmount: currentAmount,
      amounts: amounts
    };
    return _this;
  }

  _createClass(Deposit, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          selectedAccount = _state.selectedAccount,
          selectedMethod = _state.selectedMethod,
          currentAmount = _state.currentAmount,
          amounts = _state.amounts;

      var currentStep = this.state.currentStep;

      var _props = this.props,
          methods = _props.methods,
          payments = _props.payments,
          currency = _props.currency,
          intl = _props.intl,
          renderError = _props.renderError,
          initialState = _props.initialState;


      var disableAmount = selectedMethod.providerType.toLowerCase() === 'siru';

      var selectedMethodDetail = payments.find(function (payment) {
        return matchProviderType(payment, selectedMethod);
      });

      var paymentDetail = PaymentAccountForms[selectedMethod.txType];
      var PaymentAccountForm = paymentDetail ? paymentDetail.component : null;
      var defaultAccountData = paymentDetail ? paymentDetail.parser(selectedAccount) : selectedAccount;

      // in the case got error use the previous data
      if (initialState) {
        defaultAccountData = initialState.accountData;
      }

      return React.createElement(
        'div',
        null,
        renderError && renderError(),
        this.renderHeader(currentStep),
        currentStep === STEPS.SELECT_PAYMENT_METHOD && React.createElement(Form, {
          onSubmit: this.handleNextStep,
          initialValues: {
            amount: currentAmount
          },
          render: function render(_ref) {
            var handleSubmit = _ref.handleSubmit,
                invalid = _ref.invalid,
                change = _ref.change;
            return React.createElement(
              'form',
              { onSubmit: handleSubmit },
              React.createElement(PaymentMethodSelector, {
                methods: methods,
                currency: currency,
                payments: payments,
                selectedMethod: selectedMethod,
                selectedAccount: selectedAccount,
                onSelectMethod: _this2.onSelectMethod,
                onSelectAccount: _this2.onSelectAccount,
                onDeleteAccount: _this2.onDeleteAccount
              }),
              React.createElement(Amount, {
                values: amounts,
                disableCustomAmount: disableAmount,
                currency: currency
              }),
              React.createElement(
                'button',
                {
                  className: 'button secondary',
                  type: 'submit',
                  disabled: invalid },
                paymentDetail ? translate({ id: 'label.continue' }, intl) : React.createElement(
                  'span',
                  null,
                  translate({ id: 'label.submit_withdrawal' }, intl)
                )
              )
            );
          }
        }),
        currentStep === STEPS.FILL_IN && React.createElement(Form, {
          initialValues: defaultAccountData,
          onSubmit: this.onSubmit,
          render: function render(_ref2) {
            var handleSubmit = _ref2.handleSubmit;
            return React.createElement(
              'div',
              null,
              React.createElement(SelectedPaymentMethod, {
                currency: currency,
                selectedMethod: selectedMethod,
                detail: selectedMethodDetail,
                handleBack: _this2.handleBackStep
              }),
              React.createElement(
                'form',
                { onSubmit: handleSubmit },
                React.createElement(
                  'div',
                  { className: 'account-details' },
                  React.createElement(PaymentAccountForm, { account: selectedAccount })
                ),
                React.createElement(
                  'button',
                  { className: 'button secondary', type: 'submit' },
                  translate({ id: 'label.submit_withdrawal' }, intl),
                  ' ',
                  React.createElement(Money, { value: currentAmount, currency: currency })
                )
              )
            );
          }
        })
      );
    }
  }]);

  return Deposit;
}(PureComponent);

Deposit.defaultProps = {
  onSelectMethodOrAccount: function onSelectMethodOrAccount() {}
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleNextStep = function (_ref3) {
    var amount = _ref3.amount,
        bonusCode = _ref3.bonusCode;
    var selectedMethod = _this3.state.selectedMethod;

    var nextStep = PaymentAccountForms[selectedMethod.txType];

    if (!nextStep) {
      return _this3.onSubmit({
        currentAmount: amount,
        bonusCode: bonusCode
      });
    }

    _this3.setState({
      currentAmount: amount,
      bonusCode: bonusCode,
      currentStep: STEPS.FILL_IN
    });
  };

  this.handleBackStep = function () {
    _this3.setState({
      currentStep: STEPS.SELECT_PAYMENT_METHOD
    });

    _this3.props.reset();
  };

  this.onSubmit = function (data) {
    _this3.props.onSubmit(_extends({}, _this3.state, data));
  };

  this.onSelectAccount = function (_ref4) {
    var method = _ref4.method,
        account = _ref4.account;

    _this3.props.onSelectMethodOrAccount(method, account);

    var amounts = getSupportedAmounts(_this3.props.currency, method.providerType);

    _this3.setState({
      selectedMethod: method,
      selectedAccount: account,
      amounts: amounts,
      currentAmount: amounts[0]
    });

    _this3.props.reset();
  };

  this.onSelectMethod = function (_ref5) {
    var method = _ref5.method;

    _this3.props.onSelectMethodOrAccount(method);

    var amounts = getSupportedAmounts(_this3.props.currency, method.providerType);

    _this3.setState({
      selectedMethod: method,
      selectedAccount: {},
      amounts: amounts,
      currentAmount: amounts[0]
    });

    _this3.props.reset();
  };

  this.onDeleteAccount = function (account) {
    _this3.props.onDeleteAccount(account);
  };

  this.renderHeader = function (step) {
    var headers = _this3.props.headers;


    var headerToRender = headers && headers.find(function (h) {
      return h.identifier === 'withdraw-step-' + step;
    });

    return headerToRender ? React.createElement('header', {
      dangerouslySetInnerHTML: { __html: marked(headerToRender.content) }
    }) : null;
  };
};

export default injectIntl(Deposit);